import { useCallback, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PartnerBoxesTableContext } from '../contexts';

export const usePartnerBoxesActionBar = () => {
  const { selection, selectAll, fetch, reset, resetSelection } = useContext(PartnerBoxesTableContext);

  const location = useLocation();
  const history = useHistory();

  const create = useCallback(() => {
    history.push('/@next/partner-boxes/create', { background: location });
  }, [history, location]);

  return { selection, resetSelection, create, selectAll, reset, fetch };
};
